module.exports = __webpack_public_path__ + "img/lingshi.24689e53.png";